(() => {
  const LOCAL_HOSTS = new Set(['127.0.0.1', 'localhost']);

  const getPanel = (scope) => {
    if (scope instanceof Element && scope.matches('[data-sa-auth-signin-panel]')) return scope;
    if (scope instanceof Element) return scope.closest('[data-sa-auth-signin-panel]');
    return null;
  };

  const readEmail = (scope) => {
    const root = scope instanceof Element ? scope : document;
    const input = root.querySelector('[data-sa-auth-email]');
    if (!(input instanceof HTMLInputElement)) return '';
    return input.value.trim();
  };

  const authOrigin = () => {
    const shopOrigin = document.documentElement.dataset.saShopOrigin;
    if (LOCAL_HOSTS.has(window.location.hostname) && shopOrigin) return shopOrigin;
    return window.location.origin;
  };

  const buildReturnTo = (panel) => {
    let returnTo = window.location.pathname + window.location.search;

    if (!returnTo || returnTo.startsWith('/customer_authentication')) {
      returnTo = panel?.dataset.saAuthReturnTo || '/';
    }

    const previewThemeId = document.documentElement.dataset.saPreviewThemeId;
    if (previewThemeId && !returnTo.includes('preview_theme_id')) {
      returnTo += `${returnTo.includes('?') ? '&' : '?'}preview_theme_id=${previewThemeId}`;
    }

    return returnTo;
  };

  const redirectToCustomerAuth = (email, scope) => {
    const panel = getPanel(scope) || document.querySelector('[data-sa-auth-signin-panel]');
    const loginPath = panel?.dataset.saAuthLoginPath || '/customer_authentication/login';
    const returnTo = buildReturnTo(panel);

    if (LOCAL_HOSTS.has(window.location.hostname)) {
      sessionStorage.setItem('sa-local-dev-return', window.location.href);
      document.querySelectorAll('[data-sa-local-dev-note]').forEach((note) => {
        note.hidden = false;
      });
    }

    const url = new URL(loginPath, authOrigin());
    url.searchParams.set('return_to', returnTo);
    if (email) url.searchParams.set('login_hint', email);

    window.location.assign(url.toString());
    return true;
  };

  const continueAuth = (scope) => {
    const root = scope instanceof Element ? scope : document;
    const emailInput = root.querySelector('[data-sa-auth-email]');

    if (emailInput instanceof HTMLInputElement) {
      emailInput.value = emailInput.value.trim();
      if (!emailInput.value) {
        emailInput.focus();
        emailInput.reportValidity?.();
        return false;
      }
      if (!emailInput.checkValidity?.()) {
        emailInput.reportValidity?.();
        return false;
      }
    }

    const email = readEmail(root);
    return redirectToCustomerAuth(email, root);
  };

  document.querySelectorAll('[data-sa-auth-continue]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = button.closest('[data-sa-auth-signin-panel]');
      continueAuth(panel || document);
    });
  });

  document.querySelectorAll('[data-sa-auth-email]').forEach((input) => {
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      const panel = input.closest('[data-sa-auth-signin-panel]');
      continueAuth(panel || document);
    });
  });

  if (LOCAL_HOSTS.has(window.location.hostname)) {
    document.querySelectorAll('[data-sa-local-dev-note]').forEach((note) => {
      note.hidden = false;
    });
  }

  const root = document.querySelector('[data-sa-auth]');
  if (!root) return;

  const loginPanel = root.querySelector('[data-sa-login]');
  const registerPanel = root.querySelector('[data-sa-register]');
  const authTabs = root.querySelectorAll('[data-sa-auth-tab]');

  const setAuthView = (mode) => {
    const isRegister = mode === 'register';
    if (loginPanel) loginPanel.hidden = isRegister;
    if (registerPanel) registerPanel.hidden = !isRegister;
    authTabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.saAuthTab === mode);
    });
    root.dataset.saAuthView = mode;
  };

  if (root.hasAttribute('data-sa-dual-auth')) {
    const urlView = new URLSearchParams(window.location.search).get('view');
    if (urlView === 'register') setAuthView('register');
    else if (urlView === 'login' || urlView === 'sign-in') setAuthView('login');
  }

  const recoverPanel = root.querySelector('[data-sa-recover]');

  const showRecover = () => {
    if (!loginPanel || !recoverPanel) return;
    loginPanel.hidden = true;
    recoverPanel.hidden = false;
    recoverPanel.querySelector('input:not([type="hidden"])')?.focus();
  };

  const showLogin = () => {
    if (!loginPanel || !recoverPanel) return;
    recoverPanel.hidden = true;
    loginPanel.hidden = false;
    loginPanel.querySelector('input:not([type="hidden"])')?.focus();
  };

  root.querySelector('[data-sa-recover-open]')?.addEventListener('click', (event) => {
    event.preventDefault();
    showRecover();
    history.replaceState(null, '', '#recover');
  });

  root.querySelector('[data-sa-recover-cancel]')?.addEventListener('click', (event) => {
    event.preventDefault();
    showLogin();
    history.replaceState(null, '', window.location.pathname + window.location.search);
  });

  if (window.location.hash === '#recover' || recoverPanel?.querySelector('[data-sa-recover-success]')) {
    showRecover();
  }

  const tagsInput = root.querySelector('[data-sa-tags]');
  const updateTags = () => {
    if (!tagsInput) return;
    const selected = [...root.querySelectorAll('[data-sa-cat-toggle].is-selected')]
      .map((el) => el.dataset.tag)
      .filter(Boolean);
    tagsInput.value = ['newsletter', ...selected].join(', ');
  };

  root.querySelectorAll('[data-sa-cat-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const on = !button.classList.contains('is-selected');
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-pressed', String(on));
      updateTags();
    });
  });
  updateTags();

  root.querySelectorAll('[data-sa-password-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('input');
      if (!input) return;
      const hidden = input.type === 'password';
      input.type = hidden ? 'text' : 'password';
      button.setAttribute('aria-pressed', String(hidden));
      button.textContent = hidden ? 'Hide' : 'Show';
    });
  });
})();
